import * as React from 'react';
import {Shimmer} from "@atoms/Loaders/Shimmer";

export const ApartmentThumbLoader: React.FC = () => {
    return (
        <Shimmer style={{
            width: "calc(100% - 10px)",
            height: "100%",
            margin: "0 10px 0 0",
            minHeight: 133,
        }} />
    )
};
